<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2" align-v="end">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">{{ $route.meta.label }}</h1>
          <b-form-input size="sm" v-model="search.main" placeholder="Filtrar por nombre"></b-form-input>
        </b-col>
        <b-col>
          <span class="float-right">
            <i class="fa fa-lg fa-info-circle text-info"></i>
            Para moverse horizontalmente por la tabla, mantenga presionada la tecla SHIFT y utilice la rueda del mouse.
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            responsive
            hover
            ref="table"
            :items="filteredItems"
            :busy.sync="loading"
            sticky-header="600px"
            :no-border-collapse="true"
            :fields="fields"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(id)="data">
              <span class="text-uppercase">{{ data.item.id }}</span>
            </template>
            <template #head()="{ field }">
              <div v-if="field.isCertificate">
                {{ field.label }} <br />
                <b-form-input
                  size="sm"
                  :name="field.key"
                  v-model="search[field.key]"
                  :placeholder="`Filtrar por ${field.label}`"
                ></b-form-input>
              </div>
            </template>
            <template #cell()="{ item, field, index }">
              <div class="text-primary" v-if="!field.isCertificate">
                <modal-edit-productores
                  :id="`${field.key}-${index}`"
                  :data="item"
                  :text="item[field.key]"
                  :field="field.key"
                  :value="item[field.key]"
                  :headings="fields"
                  @update="updateRow"
                ></modal-edit-productores>
              </div>
              <div class="text-primary" v-else>
                <modal-update-certificates
                  :id="`${field.key}-${index}`"
                  :data="item"
                  :text="item[field.key]"
                  :field="field.key"
                  :value="item[field.key]"
                  :headings="fields"
                  :input-options="field.inputOptions"
                  @update="updateRow"
                />
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ModalEditProductores from "./ModalEditProductores.vue";
import ModalUpdateCertificates from "./ModalUpdateCertificates.vue";
export default {
  name: "Productores",
  components: {
    ModalEditProductores,
    ModalUpdateCertificates
  },
  data() {
    return {
      search: {
        main: ""
      },
      items: [],
      loading: false,
      fields: [
        { key: "id", label: "ID", stickyColumn: true },
        { key: "name", label: "Nombre", stickyColumn: true, class: "font-weight-bold bg-light" },
        { key: "code", label: "CSG" },
        { key: "ggn", label: "GGN" },
        { key: "short_name", label: "Nombre corto" },
        { key: "region", label: "Región" },
        { key: "province", label: "Provincia" },
        { key: "township", label: "Comuna" }
        // { key: "company", label: "Empresa" }
        // { key: "certificates", label: "Certificados" },
        // { key: "conditions", label: "Condiciones" }
      ],
      certificates: [],
      filteredItems2: []
    };
  },
  computed: {
    filteredItems() {
      let result = [];
      result = this.items.filter((item) => {
        return item.name.toLowerCase().includes(this.search.main.toLowerCase());
      });
      const keyList = Object.keys(this.search);
      keyList.forEach((key) => {
        if (key !== "main" && this.search[key] !== "") {
          result = result.filter((item) => {
            return item[key].toLowerCase().includes(this.search[key].toLowerCase());
          });
        }
      });
      return result;
    }
  },
  methods: {
    doFilter(e) {
      this.loading = true;
      this.search[e.target.name] = e.target.value;
      console.log("ACAACK!!! 🐔", this.search);
      this.$nextTick(() => {
        this.$forceUpdate();
        this.loading = false;
      });
      // this.filteredItems2 = [];
      // const res = await this.filterItems();
      // this.filteredItems2 = res;
      // setTimeout(() => {
      //   this.$refs.table.refresh();
      //   this.loading = false;
      // }, 500);
    },
    // filterItems() {
    //   return new Promise((resolve) => {
    //     let result = [];
    //     result = this.items.filter((item) => {
    //       return item.name.toLowerCase().includes(this.search.main.toLowerCase());
    //     });
    //     const keyList = Object.keys(this.search);
    //     keyList.forEach((key) => {
    //       if (key !== "main" && this.search[key] !== "") {
    //         result = result.filter((item) => {
    //           return item[key].toLowerCase().includes(this.search[key].toLowerCase());
    //         });
    //       }
    //     });
    //     resolve(result);
    //   });
    // },
    getOptionColor(key, option) {
      const fieldObj = this.fields.find((f) => f.key === key);
      if (fieldObj) {
        const optionObj = fieldObj.inputOptions.find((o) => o.label === option);
        if (optionObj) {
          return optionObj.color;
        }
      }
      return "";
    },
    updateRow(item) {
      const index = this.items.findIndex((i) => i.id === item.id);
      this.items.splice(index, 1, item);
      this.filteredItems2.splice(index, 1, item);
    },
    async getCertificatesConfig() {
      this.loading = true;
      try {
        const clientID = this.$store.state.user.ID_CLIENTE;
        const response = await this.$axios.get(`/api/qc/certificate_config/${clientID}/by_client/?no_page`);
        this.certificates = response.data.config;
        const certificatesKeys = this.certificates.map((item) => ({
          key: item.key,
          label: item.label,
          isCertificate: true,
          class: "text-center",
          inputOptions: item.inputOptions
        }));
        this.fields = [...this.fields, ...certificatesKeys];
      } catch (error) {}
    },
    async getOrigins() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/v1/origin/?no_page");
        this.items = response.data;
        const certificatesKeys = this.certificates.map((item) => item.key);
        for (let item of this.items) {
          item["_cellVariants"] = {};
          for (let key of certificatesKeys) {
            if (item.certificates.length > 0) {
              const itemCertificates = item.certificates.map((item) => ({
                key: item.split(":")[0],
                value: item.split(":")[1]
              }));
              const certificate = itemCertificates.find((item) => item.key === key);
              if (certificate) {
                item[key] = certificate.value;
                item["_cellVariants"] = {
                  ...item["_cellVariants"],
                  [key]: this.getOptionColor(key, certificate.value)
                };
              } else {
                item[key] = "-";
              }
            } else {
              item[key] = "-";
            }

            // item[key] = item.certificates.find((c) => c.key === key).value;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    this.getCertificatesConfig().then(() => {
      this.getOrigins().then(() => {
        this.filteredItems2 = this.items;
      });
    });
  }
};
</script>

<style scoped>
>>> table td {
  white-space: nowrap;
}
</style>
